import * as XLSX from 'xlsx';

export const downloadTransactionExcel = (transaction: any) => {
    // Prepare data for Excel matching the modal display
    const excelData = [
        { 'فیلد': 'مبلغ تراکنش (ریال)', 'مقدار': `${(transaction.amount || transaction.req_total_price || 0).toLocaleString('fa-IR')} ریال` },
        { 'فیلد': 'قیمت لحظه ای طلا', 'مقدار': `${(transaction.req_price_gold || 0).toLocaleString('fa-IR')} ریال` },
        { 'فیلد': 'وزن طلا (گرم)', 'مقدار': `${transaction.req_gold_weight || '-'} گرم` },
        { 'فیلد': 'نام نماینده', 'مقدار': transaction.shop || transaction.payer_name || '-' },
        { 'فیلد': 'تاریخ و ساعت تراکنش', 'مقدار': transaction.created_at ? new Date(transaction.created_at * 1000).toLocaleDateString('fa-IR') : '-' },
        { 'فیلد': 'شناسه دستگاه (IMEI)', 'مقدار': transaction.imei || '-' },
        { 'فیلد': 'کد تراکنش', 'مقدار': transaction.transaction_code || '-' },
        { 'فیلد': 'کد رهگیری', 'مقدار': transaction.authority || transaction.tracking_code || '-' },
        { 'فیلد': 'کد پرداخت شتابی', 'مقدار': transaction.payment_internal_credit_id || '-' },
        { 'فیلد': 'کد هش', 'مقدار': transaction.hash || '-' },
    ];

    // Remove duplicate entries (if any)
    const uniqueExcelData = excelData.filter((item, index, self) =>
        index === self.findIndex((t) => t['فیلد'] === item['فیلد'])
    );

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(uniqueExcelData);

    // Set column widths
    ws['!cols'] = [{ wch: 25 }, { wch: 50 }];

    // Style the header row
    const range = XLSX.utils.decode_range(ws['!ref'] || 'A1:B1');
    for (let row = range.s.r; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: 0 });
        if (ws[cellAddress]) {
            ws[cellAddress].s = {
                font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
                fill: { fgColor: { rgb: "7367F0" } },
                alignment: { horizontal: "center" }
            };
        }

        // Style the value column
        const valueCellAddress = XLSX.utils.encode_cell({ r: row, c: 1 });
        if (ws[valueCellAddress]) {
            ws[valueCellAddress].s = {
                font: { sz: 11 },
                alignment: { horizontal: "left" }
            };
        }
    }

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'جزئیات تراکنش طلا');

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    const filename = `transaction_${transaction.id || transaction.transaction_code || 'detail'}_${timestamp}.xlsx`;

    // Download file
    XLSX.writeFile(wb, filename);
};